import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramCompareGetAccounts.graphql';
import { Query, QueryinstagramCompareGetAccountsArgs } from '../../__generated__/globalTypes';

export const useInstagramCompareGetAccountsQuery = (
  options?: QueryHookOptions<Query, QueryinstagramCompareGetAccountsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramCompareGetAccountsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramCompareGetAccountsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramCompareGetAccountsArgs>
): QueryResult<Query, QueryinstagramCompareGetAccountsArgs> & {
  getInstagramCompareGetAccounts: LazyQueryExecFunction<Query, QueryinstagramCompareGetAccountsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramCompareGetAccounts, result] = useLazyQuery<Query, QueryinstagramCompareGetAccountsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramCompareGetAccounts, ...result };
};

export const useInstagramCompareGetAccountsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramCompareGetAccounts = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramCompareGetAccountsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramCompareGetAccountsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramCompareGetAccounts };
};
// Suspense Query Hooks
export const useInstagramCompareGetAccountsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramCompareGetAccountsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramCompareGetAccountsArgs>(QUERY, {
    ...options
  });

  return result;
};
